var exports = {
  "Lq": "OperatorPassOfferModal.module__loading___VDQ2cH",
  "N4": "OperatorPassOfferModal.module__note___VDQ2cH",
  "IQ": "OperatorPassOfferModal.module__consentBox___VDQ2cH",
  "KG": "OperatorPassOfferModal.module__consentBoxError___VDQ2cH",
  "Dn": "OperatorPassOfferModal.module__consentError___VDQ2cH",
  "eA": "OperatorPassOfferModal.module__consentCheckbox___VDQ2cH",
  "t6": "OperatorPassOfferModal.module__consentLabel___VDQ2cH",
};

module.exports = exports;
